import { render } from "./digital-incorporation-form-invalid.vue?vue&type=template&id=71caf9f8&scoped=true"
const script = {}

import "./digital-incorporation-form-invalid.vue?vue&type=style&index=0&id=71caf9f8&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71caf9f8"]])

export default __exports__